import React, { useMemo } from 'react';
import { Icon } from '../../concepts/resources/Icon';
import { Colors } from '../../ui';
import { Tip } from '../../ui/Tip';
import { Flexer } from '../dashboard/elements/LayoutElements';

type CodeLang = { compile(code: string): any };

export const CodeEditorStatus = ({ code, lang }: { code: string, lang: CodeLang }) => {

    const [ok, info] = useMemo(() => {
        try {
            lang.compile(code);
            return [true, 'OK'] as const;
        }
        catch (err) {
            return [false, err.message] as const;
        }
    }, [code]);

    return <Flexer flex="row" gap="1">
        {ok && <Icon color={Colors.positive} size="1" src="deqo://icons/hero-mini/check-circle" />}
        {!ok &&
            <Tip text={info}>
                <Icon color={Colors.negative} size="1" src="deqo://icons/hero-mini/x-circle" />
            </Tip>
        }
    </Flexer>;
};
